var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5833 3.75H5.41667C4.22005 3.75 3.25 4.72005 3.25 5.91667V7.18587C3.25 7.76051 3.47827 8.3116 3.88461 8.71794L10.1987 15.0321C10.6051 15.4384 10.8333 15.9895 10.8333 16.5641V22.1667V22.4762C10.8333 23.1615 11.662 23.5047 12.1466 23.0201L13 22.1667L14.5321 20.6346C14.9384 20.2283 15.1667 19.6772 15.1667 19.1026V16.5641C15.1667 15.9895 15.3949 15.4384 15.8013 15.0321L22.1154 8.71794C22.5217 8.3116 22.75 7.76051 22.75 7.18587V5.91667C22.75 4.72005 21.78 3.75 20.5833 3.75Z",
    stroke: "#4E465E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8a759f28701bf847652850c2111f9738.svg";
export { ForwardRef as ReactComponent };